import abs from "../static/partners/abs.png";
import migrapreneur from "../static/partners/migrapreneur.png";
import phineo from "../static/partners/phineo.png";
import wahlheymat from "../static/partners/wahlheymat.png";

/**
 * Same logos, links and destinations as the pre-redesign site's partner
 * strip (see the old Partners.tsx) and as currently live on tendbe.com.
 *
 * Each source file carries a different amount of internal transparent
 * padding around the actual mark (measured by scanning each PNG's alpha
 * channel for its visible bounding box), so displaying them at a shared
 * `height: Npx` would make some illegible next to others - e.g. abs.png's
 * mark sits inside a canvas nearly 3x its own height. `crop` values below
 * were computed from those measured bounding boxes so every logo's visible
 * ink renders at a consistent ~23.96px tall, cropped via a clipped, absolutely
 * positioned <img> rather than by editing the source files. Re-measure and
 * update these if a logo file is ever replaced.
 */
export const trustedPartners = [
  {
    name: "AsiaBerlin Summit",
    src: abs,
    url: "https://asia.berlin/",
    crop: { windowWidth: 36.6, imgWidth: 46.0, imgHeight: 66.5, offsetX: -1.8, offsetY: -21.1 },
  },
  {
    name: "Migrapreneur",
    src: migrapreneur,
    url: "https://migrapreneur.org/",
    crop: { windowWidth: 38.8, imgWidth: 57.0, imgHeight: 57.0, offsetX: -9.1, offsetY: -16.8 },
  },
  {
    name: "PHINEO",
    src: phineo,
    url: "https://www.phineo.org/",
    crop: { windowWidth: 29.3, imgWidth: 29.3, imgHeight: 24.0, offsetX: 0, offsetY: 0 },
  },
  {
    name: "Wahlheymat",
    src: wahlheymat,
    url: "https://wahlheymat.de/",
    crop: { windowWidth: 144.4, imgWidth: 159.3, imgHeight: 93.3, offsetX: -8.4, offsetY: -36.4 },
  },
];
